// hooks/usePrepareVideoPlayer.ts
import Hls from "hls.js";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/config/routes";

export const usePrepareLive = (
  videoRef: React.RefObject<HTMLVideoElement>,
  availableSubs?: number[],
  streamUrl?: string,
) => {
  const token = localStorage.getItem("splay:access");
  const navigate = useNavigate();

  useEffect(() => {
    if (!videoRef.current || !streamUrl) return;

    let hls: Hls | null = null;

    if (Hls.isSupported()) {
      hls = new Hls({
        xhrSetup: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
      });

      hls.loadSource(streamUrl);
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.ERROR, function (_, data) {
        const res = data.networkDetails.response;
        if (res == "not_subscription") {
          navigate(`${ROUTES.SUBS}?allowed=${availableSubs?.map((e: number) => `${e}`)}`);
        }
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      videoRef.current.src = streamUrl;
    }

    return () => {
      hls?.destroy();
    };
  }, [videoRef, streamUrl, token]);
};
